import type { FC } from 'react';

import FormLabel from '../FormLabel';
import FormNumberInput from '../FormNumberInput';
import FormVolumeUnitSelect from '../FormVolumeUnitSelect';

interface Props {
  autoFocus?: boolean;
  className?: string;
  hideErrorMessage?: boolean;
  isDisabled?: boolean;
  isOptional?: boolean;
  isRequired?: boolean;
  label?: string;
  name: string;
}

const FormVolumeInput: FC<Props> = (props) => {
  const { autoFocus, className, hideErrorMessage, isDisabled, isOptional, isRequired, label = 'Volume', name } = props;

  return (
    <div className={className}>
      <FormLabel isOptional={isOptional} isRequired={isRequired} label={label} name={`${name}.value`} />
      <div className="flex flex-row space-x-1 whitespace-nowrap">
        <FormNumberInput
          autoFocus={autoFocus}
          className="flex-1 min-w-20"
          disabled={isDisabled}
          hideErrorMessage={hideErrorMessage}
          hideLabel={true}
          isRequired={isRequired}
          min={0}
          name={`${name}.value`}
          placeholder="0"
          step="any"
        />
        <FormVolumeUnitSelect
          className="w-24"
          hideErrorMessage={hideErrorMessage}
          hideLabel={true}
          isDisabled={isDisabled}
          isRequired={isRequired}
          name={`${name}.unit`}
          renderMenuInPortal={true}
        />
      </div>
    </div>
  );
};

export type { Props as FormVolumeInputProps };
export default FormVolumeInput;
